import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ProjetService } from '../../../../services/projet.service';
import { ToastrService, GlobalConfig } from 'ngx-toastr';
import { AuthenticationService } from '../../../../auth/service';

@Component({
    selector: 'app-ajout-projet',
    templateUrl: './ajout-projet.component.html',
    styleUrls: ['./ajout-projet.component.scss']
})
export class AjoutProjetComponent implements OnInit {
    @Input() clientId!: number;
    @Input() stationId!: number;
    @Input() projectData: any = null;
    @Output() projectSaved = new EventEmitter<void>();
    @ViewChild('modalLG') modalTemplate?: TemplateRef<any>;

    private options: GlobalConfig;
    Ang;

    data: any = {
        id: 0,
        client_id: 0,
        station_id: 0,
        nom: '',
        statut: true
    };

    modalRef: NgbModalRef | null = null;

    constructor(
        private toastr: ToastrService,
        private modalService: NgbModal,
        private projetService: ProjetService,
        private authService: AuthenticationService
    ) {
        this.options = this.toastr.toastrConfig;
    }

    ngOnInit(): void {}

    openModal(): void {
        if (!this.projectData) {
            this.resetForm();
        } else {
            this.data = {
                nom: this.projectData.libelle,
                statut: this.projectData.statut
            };
        }

        const options: NgbModalOptions = {
            centered: true,
            backdrop: 'static',
            keyboard: true,
            size: 'lg'
        };
        this.modalRef = this.modalService.open(this.modalTemplate, options);
    }


    onSubmit(): void {
        const payload = {
            client_id: this.clientId,
            libelle: this.data.nom.trim(),
            statut: this.data.statut
        };

        if (!payload.libelle) {
            this.toastr.error('Le nom du projet est requis.', 'Erreur');
            return;
        }

        const request = this.projectData?.id
            ? this.projetService.updateProject(this.stationId, this.projectData.id, payload)
            : this.projetService.addProject(this.stationId, payload);

        request.subscribe({
            next: () => {
                this.modalRef?.close();
                this.projectSaved.emit();
                this.toastr.success(
                    this.projectData ? 'Modification enregistrée avec succès !' : 'Projet ajouté avec succès !',
                    '',
                    { positionClass: 'toast-top-right', toastClass: 'toast ngx-toastr custom-success-toast' }
                );
            },
            error: (err) => {
                this.toastr.error('Erreur lors de l’opération sur le projet', err);
            }
        });
    }

    private resetForm(): void {
        this.data = {
            nom: '',
            statut: true
        };
        this.projectData = null;
    }
}
